<div class="row">
    <div class="col-md-6" style="padding-left: 0px;">
        <div class="materials-heading">Supporting Material</div>
        <div *ngFor="let links of resourcesList.relatedlinks" style="padding-bottom: 2%;">
            <div *ngIf="links.Access_Mechanism == 2">
                <a href="{{links.Link}}" target="_blank">{{links.Title}}</a>
            </div>
            <div *ngIf="links.Access_Mechanism == 1">
                <a class="link" (click)="resourceCode(links)" target="_blank">
                    {{links.Title}}</a>
            </div>
        </div>
    </div>    
    <div class="col-md-3" style="padding-left: 0px;" *ngIf="accessCodePresent">
        <div *ngIf="resourcesList['codeaccessmechanism'][0].id == 1">
        <button type="button" class="btn btn-primary" title="Click to access code" (click)= accessCode()>
            <span class="access-code-text">CODE REPO</span>
        </button>
        </div>
        <div *ngIf="resourcesList['codeaccessmechanism'][0].id == 2">
            <a href="{{resourcesList['access_code']}}" target="_blank"><button type="button" class="btn btn-primary" title="Click to access code">
                <span class="access-code-text">CODE REPO</span>
            </button>
            </a>
            </div>
    </div>
    <div class="col-md-3" style="padding-left: 0px;">
        <button type="button" class="btn btn-primary" title="Click to request access" data-toggle="modal"
                data-target="#requestAccessModal">
            <span class="access-code-text">REQUEST ACCESS</span>
        </button>
    </div>
</div>
 
